import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anti-ragging-squad',
  templateUrl: './anti-ragging-squad.component.html',
  styleUrls: ['./anti-ragging-squad.component.scss']
})
export class AntiRaggingSquadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
